import React, { ChangeEvent } from 'react';
import { Search } from 'lucide-react';

export type ReservationFormClientFieldsProps = {
  time: string;
  isEditing: boolean;
  name: string;
  phone: string;
  email: string;
  birthdate: string;
  notes: string;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => void;
  onOpenCrmSearch: () => void;
};

export default function ReservationFormClientFields({
  time,
  isEditing,
  name,
  phone,
  email,
  birthdate,
  notes,
  onChange,
  onOpenCrmSearch,
}: ReservationFormClientFieldsProps) {
  if (!time) return null;

  return (
    <>
      <div className="form-group">
        <label htmlFor="name">Nome do Cliente*</label>
        <div className="reservation-client-input-wrap">
          <input
            id="name"
            name="name"
            type="text"
            value={name}
            onChange={onChange}
            required
          />
          {!isEditing && (
            <button
              type="button"
              className="reservation-client-search-trigger"
              onClick={onOpenCrmSearch}
              aria-label="Buscar cliente no CRM"
              title="Buscar cliente no CRM"
            >
              <Search size={17} />
            </button>
          )}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="phone">Telefone (opcional)</label>
        <input
          id="phone"
          name="phone"
          type="tel"
          value={phone}
          onChange={onChange}
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">E-mail (opcional)</label>
        <input
          id="email"
          name="email"
          type="email"
          value={email}
          onChange={onChange}
          placeholder="cliente@exemplo.com"
        />
      </div>

      <div className="form-group">
        <label htmlFor="birthdate">Data de nascimento (opcional)</label>
        <input
          id="birthdate"
          name="birthdate"
          type="date"
          value={birthdate}
          onChange={onChange}
          max={new Date().toISOString().split('T')[0]}
        />
      </div>

      <div className="form-group full-width notes-group">
        <label htmlFor="notes">Observações (opcional)</label>
        <textarea
          id="notes"
          name="notes"
          value={notes}
          onChange={onChange}
          rows={3}
        />
      </div>
    </>
  );
}
